export function ErrorFallback() {
	return (
		<div className='flex min-h-screen items-center justify-center bg-gray-50'>
			<div className='text-center'>
				<h1 className='text-2xl font-semibold text-gray-900 mb-2'>Something went wrong</h1>
				<p className='text-gray-600 mb-4'>We've been notified and are working on it.</p>
				<button
					type='button'
					onClick={() => window.location.reload()}
					className='px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors'>
					Refresh Page
				</button>
			</div>
		</div>
	)
}
